import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/form'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import LoginIdentifierField from '../../../../components/input/LoginIdentifierField'
import emailLoginIdentifierKey = com.eidu.sharedlib.entity.emailLoginIdentifierKey
import phoneNumberLoginIdentifierKey = com.eidu.sharedlib.entity.phoneNumberLoginIdentifierKey
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction
import useHasPermission from '../../../permission/useHasPermission'
import useHasGlobalPermissions from '../../../permission/useHasGlobalPermissions'
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction

const UserViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()
  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const externalValues = entity.entity.externalValues?.asJsReadonlyMapView() ?? new Map()
  const phone = externalValues.get(phoneNumberLoginIdentifierKey) || ''
  const email = externalValues.get(emailLoginIdentifierKey) || ''

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)

  const { hasPermission } = useHasGlobalPermissions(GlobalAction.ManageAuthentication)
  const showAuthenticationInfo = hasPermission(GlobalAction.ManageAuthentication)

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      actions={hasUpdatePermission ? <Button onClick={navigateToEdit}>Edit</Button> : undefined}
      showBack
    >
      <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
      {showAuthenticationInfo && <LoginIdentifierField phone={phone} email={email} disabled />}
    </PageLayout>
  )
}

export default UserViewPage
